import { render, staticRenderFns } from "./order-detail.vue?vue&type=template&id=50c8b1e4&"
import script from "./order-detail.vue?vue&type=script&lang=js&"
export * from "./order-detail.vue?vue&type=script&lang=js&"
import style0 from "./order-detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports